// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g stroke="none" strokeWidth="1" fillRule="evenodd">
			<g transform="translate(6.000000, 3.000000)">
				<path d="M3.31071809,9.41497597 L3.31071809,4.70693677 L4.78365449,4.70693677
					L4.97885037,3.08452039 L3.31071809,3.08452039 L3.3132206,2.27248537
					C3.3132206,1.84933419 3.35878716,1.62260012 4.04760337,1.62260012
					L4.96842324,1.62260012 L4.96842324,-1.77635684e-15 L3.49527829,-1.77635684e-15
					C1.72579431,-1.77635684e-15 1.10298183,0.787046497 1.10298183,2.11061121
					L1.10298183,3.08470412 L1.77635684e-15,3.08470412 L1.77635684e-15,4.70712051
					L1.10298183,4.70712051 L1.10298183,9.41497597 L3.31071809,9.41497597 Z" />
			</g>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Facebook.js